import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/worker-xml';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/ext-searchbox';
import './xmlViewer.css';

/**
 * Codeblock viewer for xml code using react-ace
 */
export const XmlViewer = ({ value }: { value: string }) => {
  return (
    <AceEditor
      focus={true}
      placeholder={' '}
      readOnly={true}
      mode={'xml'}
      theme="monokai"
      name={'xml-viewer'}
      fontSize={14}
      showPrintMargin={true}
      showGutter={true}
      highlightActiveLine={true}
      value={value}
      wrapEnabled={false}
      editorProps={{ $blockScrolling: Infinity }}
      scrollMargin={[4, 4, 4, 0]} // Top, bottom, left, right
      width={'100%'}
      height={'95%'}
      setOptions={{ fixedWidthGutter: true }}
    />
  );
};
